import React from 'react';
import {Navigate, Outlet} from 'react-router-dom';
import {useUser} from "./AuthProvider";

// Crie um componente de rota privada
export function UnloggedRoute() {
    const { user } = useUser();

    return !(user?.token) ? <Outlet/> : <Navigate to="/"/>;
}